module.exports = __webpack_public_path__ + "static/HappyDoomsday - Glitch-a952e39b2dac32eaff25af2b6fe115b6.webm";